import { globalFileServer } from "../../../../axiosInstance";
import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import ShowCategory from "./showCategory";

const CategoriesEdit = () => {
  const [search, setSearch] = useState("");
  const { categoriesState } = useSelector((state) => ({
    categoriesState: state.category.categories,
  }));
  const [openSections, setOpenSections] = useState({
    inactive: false,
    orphans: false,
  });

  const searchFun = (e) => {
    let search = e.target.value;
    setSearch(search);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const filteredCategories = categoriesState.filter(
    (category) =>
      category.name.toLowerCase().includes(search.toLowerCase()) &&
      category.parentId === "ROOT" &&
      category.status === "ACTIVE",
  );

  const toggleSection = (sectionKey) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [sectionKey]: !prevState[sectionKey],
    }));
  };

  const allInactiveAndDescendants = useMemo(() => {
    const inactivRootIds = new Set(
      categoriesState
        .filter((cat) => cat.status === "INACTIVE" && cat.parentId === "ROOT")
        .map((cat) => cat.id || cat.Id),
    );

    const allDescendants = new Set(inactivRootIds);
    let changed = true;
    while (changed) {
      changed = false;
      for (const cat of categoriesState) {
        const catId = cat.id || cat.Id;
        const catParentId = cat.parentId || cat.FatherId;
        if (allDescendants.has(catParentId) && !allDescendants.has(catId)) {
          allDescendants.add(catId);
          changed = true;
        }
      }
    }
    return allDescendants;
  }, [categoriesState]);

  return (
    <div className="category-edit">
      <h1 className="title-role">ניהול מחלקות</h1>
      <div className="items-container">
        <div className="flex-container">
          <div className="search">
            <input
              onChange={searchFun}
              value={search}
              type="text"
              placeholder="חיפוש..."
            />
            {search ? (
              <img
                loading="lazy"
                className="close"
                onClick={clearSearch}
                src={globalFileServer + "iconcss/close.svg"}
                alt="close"
              />
            ) : (
              <img
                loading="lazy"
                src={globalFileServer + "iconcss/search.svg"}
                alt="search"
              />
            )}
          </div>
        </div>
      </div>
      <ShowCategory categoriesState={filteredCategories} />
      <div style={{ textAlign: "center" }}>
        <h2
          onClick={() => toggleSection("inactive")}
          style={{ cursor: "pointer" }}
        >
          קטגוריות / מקבצים לא פעילים{openSections.inactive ? " ▲" : " ▼"}
        </h2>
        {openSections.inactive && (
          <ShowCategory
            categoriesState={categoriesState?.filter((cat) => {
              const catId = cat.id || cat.Id;
              return allInactiveAndDescendants.has(catId);
            })}
            parentId="ROOT"
            level={0}
            isMainSection={false}
          />
        )}
      </div>
      <div style={{ textAlign: "center" }}>
        <h2
          onClick={() => toggleSection("orphans")}
          style={{ cursor: "pointer" }}
        >
          קטגוריות / מקבצים יתומים{openSections.orphans ? " ▲" : " ▼"}
        </h2>
        {openSections.orphans && (
          <ShowCategory
            categoriesState={categoriesState?.filter(
              (cat) => cat.parentId === null,
            )}
            parentId={null}
            level={0}
            isMainSection={false}
          />
        )}
      </div>
    </div>
  );
};

export default CategoriesEdit;
